import { render, staticRenderFns } from "./more-filter.vue?vue&type=template&id=c771a484&scoped=true"
import script from "./more-filter.vue?vue&type=script&lang=ts"
export * from "./more-filter.vue?vue&type=script&lang=ts"
import style0 from "./more-filter.vue?vue&type=style&index=0&id=c771a484&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c771a484",
  null
  
)

export default component.exports